export default __webpack_public_path__ + "static/media/Search.5923059a.svg";